import { render, staticRenderFns } from "./VerticalDivider.vue?vue&type=template&id=01a917c8&scoped=true&"
import script from "./VerticalDivider.vue?vue&type=script&lang=js&"
export * from "./VerticalDivider.vue?vue&type=script&lang=js&"
import style0 from "./VerticalDivider.vue?vue&type=style&index=0&id=01a917c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a917c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
